import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import MobileHeader from '../../components/MobileHeader/MobileHeader';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';

import Modal from 'react-bootstrap/lib/Modal';
import Input from 'react-bootstrap/lib/Input';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

const ProfilePassword = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	getInitialState() {
		return {
			passwordChanged: false
		}
	},

	changePassword(e) {
		e.preventDefault();
		this.setState({passwordChanged: true});
	},

	render() {
		let hideModal = () => this.setState({passwordChanged: false});
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
					title='Password'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<form className="screen-content section-wrap bg-gray" onSubmit={this.changePassword}>
					<div className="section-body">

						<FormSection>
							<FormGroup
								label="Old password"
							>
								<Input type="password"/>
							</FormGroup>
							<FormGroup
									label="New password"
							>
								<Input type="password"/>
							</FormGroup>
							<FormGroup
									label="Confirm password"
							>
								<Input type="password"/>
							</FormGroup>
						</FormSection>
					</div>
					<div className="section-footer">
						<TouchButton type="submit" bsStyle="primary" bsSize="large" block>Change password</TouchButton>
					</div>
				</form>
				<Modal
					show={this.state.passwordChanged}
					onHide={hideModal}
					aria-labelledby="modal-hint"
				>
					<Modal.Body>
						<p className="text-center">Your password has been changed!</p>
					</Modal.Body>
					<Modal.Footer>
						<TouchButton onClick={hideModal}>Ok</TouchButton>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
});

export default ProfilePassword;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/ProfilePassword.js
 **/